import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// styles
import styles from "./footerStyle";
const useStyles = makeStyles(styles);

export default function Footer() {
  const classes = useStyles();
  return (
    <Grid container spacing={0} className={classes.foooterContainer}>
      <Grid item xs={12} sm={4}></Grid>
      <Grid item xs={12} sm={4}></Grid>
      <Grid item xs={12} sm={4}></Grid>
      <Grid item xs={12} sm={12}>
        <div className={classes.copyright}>
          Copyright © togamin All Rights Reserved.
        </div>
      </Grid>
    </Grid>
  );
}
